import { render, staticRenderFns } from "./EstatusArmaDialogComponent.vue?vue&type=template&id=72bb76b8&scoped=true"
import script from "./EstatusArmaDialogComponent.vue?vue&type=script&lang=js"
export * from "./EstatusArmaDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./EstatusArmaDialogComponent.vue?vue&type=style&index=0&id=72bb76b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb76b8",
  null
  
)

export default component.exports